export default "__VITE_ASSET__pHL90uhv__ 740w";